<template>
  <div class="accepted-offers container-fluid">
    <div class="row title-row">
      <div class="col-12">{{title}}</div>
    </div>
    <div class="row offers-row">
      <AcceptedOffer class="col-12" v-for="(offer, index) in acceptedOffers" :class="{ last: index === acceptedOffers.length-1 }" :key="offer.offer.displayedOfferId ?? offer.offer.id" :offer="offer"></AcceptedOffer>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import AcceptedOffer from './mini-offers/AcceptedOffer.vue'

export default {
  name: 'AcceptedOffers',
  props: ['isExtra', 'title'],
  components: {
    AcceptedOffer
  },
  data () {
    return {
    }
  },
  computed: {
    acceptedOffers () {
      return this.submits.filter((offer) => offer.status === 'Accepted' && !this.isExtra === !offer.offer.isExtra)
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer
    }),
    ...mapGetters({
      submits: 'consumer/leadRequests/getRequests'
    })
  },
  methods: {
  }
}
</script>

<style scoped>
.row {
  margin-right: calc(var(--bs-gutter-x) * -1);
  margin-left: calc(var(--bs-gutter-x) * -1);
}
.accepted-offers {
  border: 1px solid #d6e9c6;
  margin-bottom: 20px;
  border-radius: .25em;
  padding-bottom: 30px;
}
.accepted-offers .title-row {
  padding: 20px 0;
  border-bottom: 1px solid #d6e9c6;
  color: #3c763d;
  background-color: #dff0d8;
  font-size: 18px;
}
.accepted-offer {
  border: 1px solid #ddd;
  margin: 15px 15px 5px 15px;
  width: calc(100% - 30px);
}
</style>
